import { isBrowser } from './index'
import logger from '../logger'

export const isIe9 = (): boolean => {
  if (isBrowser) {
    return (window as any).__IS_IE9__
  }
  logger.error('call in client-side code')
  return false
}

export const isIe10 = (): boolean => {
  if (isBrowser) {
    return (window as any).__IS_IE10__
  }
  logger.error('call in client-side code')
  return false
}
